/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-process-env */
/* eslint-disable import/exports-last */
import React, { ComponentType } from 'react'

export type ErrorBoundaryFallbackProps = {
  error?: {
    message: string,
    stack?: string,
  }
  template?: ComponentType
}

const ErrorBoundaryFallback = ({ error, template }: ErrorBoundaryFallbackProps) => {
  if (process.env.NODE_ENV !== 'development') {
    return template || null
  }

  return (
    <section role="alert">
      <p>Developer Mode - Something went wrong:</p>
      <pre>{error?.message}</pre>
    </section>
  )
}

export default ErrorBoundaryFallback
